// extracted by mini-css-extract-plugin
export var card = "resourceCarousel-module--card--abfd0";
export var control = "resourceCarousel-module--control--4c75c";
export var controls = "resourceCarousel-module--controls--45fdb";
export var image = "resourceCarousel-module--image--98aed";
export var indicator = "resourceCarousel-module--indicator--3fb7a";
export var mobileCarousel = "resourceCarousel-module--mobileCarousel--2e76d";